<template>
  <div class="developer" :class="themeClass">
    <div class="banner">
      <img width="100%" :src="headerBannerSrc">
    </div>
    <div class="content">

      <div class="content-item">
        <ul class="content-con developer-list flex">
          <li
            v-for="(item, index) in developerList"
            :key="index"
            class="developer-item flex"
            @click="handleDetails(item)"
          >
            <div class="developer-item-left">
              <img :src="item.avatar" alt="">
            </div>
            <div class="developer-item-right">
              <p class="developer-tit con-tit">{{ item.Name }}</p>
              <!-- <p class="developer-name con-txt">{{ item.Name }}</p> -->
              <p class="developer-desc con-txt">{{ item.instruction }}</p>
            </div>
          </li>
        </ul>

        <!-- 更多 -->
        <div
          v-if="page.total !== developerList.length"
          class="list-more"
          @click="handleClickMore"
        >
          展示更多<br>
          <Icon type="ios-arrow-down" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { os } from '@/utils/index'
import themeMix from '@/minixs/common'

const { isPc } = os()
const assetBasicCatalog = isPc ? 'pc' : 'mobile'
const basicSrc = `assets/images/developer/${assetBasicCatalog}`

export default {
  name: 'developer-list',
  // 引入的组件
  components: {},
  // 混入
  mixins: [themeMix],
  // 当前页面的数据定义
  data() {
    return {
      headerBannerSrc: require(`@/${basicSrc}/head-banner.jpeg`),
      developerList: [],
      page: {
        total: 0,
        current: 1,
        size: 8
      }
    }
  },
  // 计算属性
  computed: {},
  // 页面初始化的时候执行的方法
  created() {},
  // html已经渲染并挂载后的执行方法
  mounted() {
    this.getDevelopersList()
  },
  // 当前页面的方法集合
  methods: {
    async getDevelopersList() {
      this.$Loading.start()
      const { data } = await this.$api.getDevelopers({
        current: this.page.current,
        size: this.page.size
      })

      this.page.current++
      this.page.total = data.count
      this.$Loading.finish()

      data.list.forEach(item => {
        this.developerList.push(item)
      })
    },
    // 跳转详情
    handleDetails(item) {
      this.$router.push({
        path: `/developers/${item.id}`
      })
    },
    handleClickMore() {
      this.getDevelopersList()
    }
  }
}
</script>

<style lang="scss" scope>
.developer {
  background-color: #000;

  .content-item {
    background-image: url(https://game.gtimg.cn/images/roblox/web201904/collect/bg01.jpg);
    background-repeat: repeat-y;
  }

  .developer-list {
    padding-top: 130PX;

    li {
		margin-bottom: 125PX;
    }
	li:nth-child(2n) {
		margin-left: 5%;
	}
  }

  .developer-item {
    width: 47.5%;
    cursor: pointer;

    .developer-item-left {
      width: 36%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 175PX;
        height: 175PX;
        border-radius: 100%;
      }
    }
    .developer-item-right {
      padding: 0 20PX 30PX 20PX;
      width: 64%;
      text-align: left;
      min-height: 205PX;
      line-height: 100%;
      background-color: rgba($color:#000, $alpha: .5);

      .developer-tit,
      .developer-name {
        margin-top: 30PX;
        line-height: normal;
      }
      .developer-desc {
        margin-top: 20PX;
        line-height: 24PX;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
    }
  }

  // 白色主题
  &.white {
    background-color: #fff;

    .content-item {
      background-image: none;
    }

    .developer-item {
      .developer-item-right {
        background-color: #f2f2f2;
      }
    }

    .con-tit,
    .con-txt {
      color: #393B3D;
    }

    .content-tit,
    .list-more {
      color: #393B3D;;
    }

  }
}

@media screen and (max-width: 800px) {
  .developer {

    .developer-list {
      padding-top: 110px;

      li {
        margin-bottom: 50px;
      }
      li:nth-child(2n) {
        margin-left: 0;
      }
    }

    .developer-item {
      width: 100%;

      .developer-item-left {
        padding: 50px 0;
        img{
          width: 280px;
          height: 280px;
        }
      }
      .developer-item-right {
        padding: 0 40px 60px 40px;
        min-height: auto;

        .developer-name, .developer-tit, .developer-desc{
          margin-top: 40px;
        }
        .developer-tit{
          font-size: 30px;
        }
        .developer-name{
          font-size: 28px;
        }
        .developer-desc{
          font-size: 24px;
          line-height: 36px;
          -webkit-line-clamp: 5;
        }
      }
      .developer-item-left,
      .developer-item-right {
        width: 100%;
        }
      }
    }
}
</style>
